import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Unit } from 'src/app/form-controls/shared/popovers/unit-popover/unit.popover';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { UnitValue, UnitValueControl } from 'src/app/form-controls/unit-value/unit-value.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { MedicationInfusionActionV3, MedicationInfusionDoseUnit } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface MedicationInfusionActionFormGroup {
	dose: FormControl<UnitQuantity | null>;
	rate: FormControl<UnitValue | null>;
}

@Component({
    selector: 'app-medication-infusion-action-controls-v3',
    templateUrl: './medication-infusion-action-controls-v3.component.html',
    styleUrls: ['../../../common.scss', './medication-infusion-action-controls-v3.component.scss'],
    imports: [ReactiveFormsModule, CommonActionControlsComponent, ActionFormComponent, UnitQuantityControl, UnitValueControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationInfusionActionControlsComponentV3 implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: MedicationInfusionActionV3;

	doseUnits: Unit[] = [
		{ label: MedicationInfusionDoseUnit.MgKgHr },
		{ label: MedicationInfusionDoseUnit.UgKgHr },
		{ label: MedicationInfusionDoseUnit.MeqKgDay },
		{ label: MedicationInfusionDoseUnit.MgKgDay },
		{ label: MedicationInfusionDoseUnit.MmolKgHr },
		{ label: MedicationInfusionDoseUnit.UgKgMin }
	];


	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as MedicationInfusionActionV3;
	}

	@Input() form!: FormGroup<MedicationInfusionActionFormGroup>;
	@Input() item!: Row | null;
	
	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('dose', this.formBuilder.control(this.action?.dose ?? null));
		this.form.addControl('rate', this.formBuilder.control(this.action?.rate ?? null));
	}
}